import React from 'react'

import { HomeCoreExperiences } from './HomeCoreExperiences'
import { HomeDashboardContent } from './HomeDashboardContent'
import { HomeHero } from './HomeHero'
import { HomePrelaunchNotice } from './HomePrelaunchNotice'

export default function DesktopHomePage() {
  return (
    <div className="browse-page--desktop flex min-h-0 flex-1 flex-col space-y-6 overflow-y-auto pb-20 sm:space-y-8 max-md:pb-0">
      <HomeHero />
      <HomePrelaunchNotice />
      <HomeDashboardContent />
      <HomeCoreExperiences />
    </div>
  )
}
